import React, { memo } from "react";
type PropsType = {
  type: {
    isPaymentError: boolean;
    isPaymentFail: boolean;
    isTimeout: boolean;
    isStreammingFail: boolean;
    isPaymentSuccess: boolean;
  };
};

const ModalContentPayment: React.FC<PropsType> = ({ type }) => {
  let message = "";
  if (type.isPaymentError) {
    message = `<p>Có lỗi trong quá trình chờ thanh toán</p>
      <p>Quý khách vui lòng kiểm tra lại các bước thực hiện thanh toán.</p>`;
  }

  if (type.isPaymentFail) {
    message = `<p>Giao dịch không thành công!</p>
      <p>Quý khách vui lòng kiểm tra lại các bước thực hiện thanh toán.</p>`;
  }

  if (type.isTimeout) {
    message = `<p>Vui lòng thử lại.</p>`;
  }
  if (type.isStreammingFail) {
    message = `<p>Quá trình thực hiện thanh toán bị gián đoạn, vui lòng thử lại</p>`;
  }
  if (type.isPaymentSuccess) {
    message = `<div className="content">
    <Image
      src='${process.env.PUBLIC_URL}/images/yayyyy.png'
      alt="thanh cong"
    />
    <div className="body">
      <p>
        Vui lòng kiểm tra SMS từ thuê bao thanh toán để nhận coupon vé
        xem phim miễn phí.
      </p>
      <p>
        Hoặc gọi <strong style={{ color: "#0045AC" }}> 1800 9090</strong> trong
        trường hợp sau 6h thanh toán nhưng chưa nhận được coupon vé xem
        phim.
      </p>
      <p>
        Chương trình áp dụng cho <strong>KHÁCH HÀNG LẦN ĐẦU ĐĂNG KÝ GALAXY PLAY</strong>
        (Khách hàng chưa từng có gói Cao Cấp và Siêu Việt)
      </p>
      <p>Vào Galaxy Play và khám phá kho phim hấp dẫn ngay.</p>
    </div>

    <div className="footer">
      <a
        href="https://galaxyplay.vn/lobby"
        className="button primary-button"
        target="_blank"
      >
        Xem phim ngay
      </a>
    </div>
  </div>`;
  }

  return (
    <div className="content" dangerouslySetInnerHTML={{ __html: message }} />
  );
};
export default memo(ModalContentPayment);
